export class Client {
  id: string;
  name: string;
}
